import { Flex } from '@/components'
import {
  ErrorLine,
  ErrorList,
  ErrorMessage,
  ErrorRowContainer,
  ErrorTitle,
  StatCardContainer,
  StatLabel,
  StatsGrid,
  StatValue,
} from './Stats.styles'
import { ParseRowError } from '@shared/models'

interface ImportResultProps {
  total: number
  inserted: number
  updated: number
  skipped: number
  ignored: number
  errors: ParseRowError[]
}

export type StatColor = 'default' | 'success' | 'warning' | 'danger'

export function ImportResultContent({ total, inserted, updated, skipped, ignored, errors }: ImportResultProps) {
  return (
    <Flex $type="column" $gap={20}>
      <StatsGrid>
        <StatCard label="Total" value={total} color="default" />
        <StatCard label="Inseridos" value={inserted} color="success" />
        <StatCard label="Atualizados" value={updated} color="success" />
        <StatCard label="Ignorados" value={skipped + ignored} color="warning" />
        <StatCard label="Erros" value={errors.length} color="danger" />
      </StatsGrid>

      {errors.length > 0 && (
        <Flex $type="column" $gap={8}>
          <ErrorTitle>Erros encontrados</ErrorTitle>
          <ErrorList>
            {errors.map((error, index) => (
              <ErrorRow key={index} error={error} />
            ))}
          </ErrorList>
        </Flex>
      )}
    </Flex>
  )
}

export function StatCard({
  label,
  value,
  color,
}: {
  label: string
  value: number | string
  color: StatColor
}) {
  return (
    <StatCardContainer $color={color}>
      <StatValue>{value}</StatValue>
      <StatLabel>{label}</StatLabel>
    </StatCardContainer>
  )
}

function ErrorRow({ error }: { error: ParseRowError }) {
  return (
    <ErrorRowContainer>
      <ErrorLine>Linha {error.row}</ErrorLine>
      <ErrorMessage>{error.message}</ErrorMessage>
    </ErrorRowContainer>
  )
}
